import React from "react";
import { useLocation, Link } from "react-router-dom";
import { MdDashboard, MdAccountCircle, MdPayments } from "react-icons/md";
import "../styles/components/_sidebar.css";

const Sidebar = ({ isCollapsed }) => {
  const location = useLocation();

  const menus = [
    { name: "Dashboard", route: "/", icon: <MdDashboard size={24} /> },
    { name: "Payments", route: "/payments", icon: <MdPayments size={24} /> },
    { name: "Customers", route: "/customers", icon: <MdAccountCircle size={24} /> },
    // { name: "Spare Parts", route: "/parts", icon: <MdCategory size={24} /> },
  ];

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <ul className="menu">
        {menus.map((menu, index) => (
          <Link to={menu.route} key={index}>
            <li className={`menu-item ${location.pathname === menu.route ? "active" : ""}`}>
              <div className="menu-icon">{menu.icon}</div>
              {!isCollapsed && <span>{menu.name}</span>}
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
